import { ModalNext } from "@ui-kit/Modal/ModalNext";
import { FunctionComponent, useCallback, useState } from "react";
import { Intro, IntroBackground } from "../Intro/Intro";
import { CreatePlan, CreatePlanBackground } from "../CreatePlan/CreatePlan";
import { OnboardingStepType } from "./OnboardingStepType";
import { useGetFeaturedEntityQuery } from "@store/services/search";
import { useAppSelector } from "@store/store";
import { selectMenuItem } from "@store/menuItem/menuItemReducer";
import { FeaturedItem } from "../FeaturedItem/FeaturedItem";
import { CookieKeys, setCookie } from "@lib/cookies";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";

import "./Onboarding.css";

/**
 * Entry point to Onboarding screens and navigating between them.
 */
const OnboardingScreens: FunctionComponent = () => {
  const menuItem = useAppSelector(selectMenuItem);
  const { data: featuredEntity } = useGetFeaturedEntityQuery({
    categoryIds: menuItem.categoryIds,
  });

  const [isOpen, setIsOpen] = useState(true);
  const [currentStep, setCurrentStep] = useState<OnboardingStepType>("intro");

  const { isMobile } = useWindowSize();

  const handleClose = useCallback(() => {
    setCookie(CookieKeys.tutorialViewed, "true");
    setIsOpen(false);
  }, []);

  const handleNextPress = useCallback((step: OnboardingStepType) => {
    setCurrentStep(step);
  }, []);

  return (
    <ModalNext
      isOpen={isOpen}
      onClose={handleClose}
      width={currentStep !== "featuredItem" ? 798 : 399}
      height={560}>
      <div className={`onboarding-component ${isMobile ? "mobile" : ""}`}>
        {currentStep !== "featuredItem" && (
          <div className={"left-content"}>
            {currentStep === "intro" && <IntroBackground />}
            {currentStep === "createPlan" && (
              <CreatePlanBackground entity={featuredEntity} />
            )}
          </div>
        )}
        <div className="right-content">
          {currentStep === "intro" && (
            <Intro
              onNextPress={handleNextPress}
              onClose={handleClose}
              entity={featuredEntity}
            />
          )}
          {currentStep === "createPlan" && (
            <CreatePlan
              onNextPress={handleNextPress}
              onClose={handleClose}
              entity={featuredEntity}
            />
          )}
          {currentStep === "featuredItem" && (
            <FeaturedItem
              entity={featuredEntity!}
              onNextPress={handleNextPress}
              onClose={handleClose}
            />
          )}
        </div>
      </div>
    </ModalNext>
  );
};

export { OnboardingScreens };
